// @ts-strict

import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ShareOpenModalStatusService {
  private isCountryModalOpen = new BehaviorSubject(false);
  public isCountryModalOpenObservable = this.isCountryModalOpen.asObservable();

  constructor() {}

  public shareModalStatus(status: boolean): void {
    this.isCountryModalOpen.next(status);
  }
}
